// extracted by mini-css-extract-plugin
export default {"action-loader-container":"ZKYUQV","action-loader":"phMsm4","rotation":"nnqc0D"};